export default __webpack_public_path__ + "static/logo-8b4829396e093fe5a108e02304592534.jpg";